import { render, staticRenderFns } from "./TermCreateModal.vue?vue&type=template&id=04690eac"
import script from "./TermCreateModal.vue?vue&type=script&lang=js"
export * from "./TermCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports